import '../App.css';
import NavBar from '../components/navbar';

import BrainImage from '../images/brain_image.png';
import ChatBot from '../images/chatbot.png';

import { useNavigate } from 'react-router-dom';

function About() {

    const navigate = useNavigate()

    return (
        <div className="homepage">
            <NavBar /> 
            <div className="aboutussection">
                <div className="abouttext">
                    <b style={{fontSize: '2.2vw'}}><u>About Us</u></b>
                    <div className="aboutustext">At SimplifyAI, we believe artificial intelligence should be practical, powerful, and personalised. <br /> <br /> We build custom AI tools that help businesses automate tedious tasks, unlock insights from data, and scale smarter without the complexity or cost of bloated enterprise solutions. From intelligent chatbots and workflow automation to advanced AI agents, every solution we deliver is tailored to your unique operations and goals. <br /> <br />We're not just AI developers. We're business problem-solvers. <br /><br /> Whether you're a fast-growing startup or an established team drowning in repetitive work, our mission is simple: <br /> <br />Free your team to focus on what matters most while AI handles the rest.</div>
                </div>
                <div className="aboutimage"><img className="brainimage" src={BrainImage} alt="brainimage" style={{marginLeft: '20%'}}/></div>
            </div>
            <div className="aboutussection">
                <div className="abouttext">
                    <b style={{fontSize: '2.2vw'}}><u>What Makes us Different?</u></b>
                    <div className="aboutustext">
                        <ul className="aboutlist">
                            <li><b>Tailored Solutions</b>: No plug-and-play templates. Every system is designed around your workflows, data, and goals.</li>
                            <li><b>Real Results</b>: We focus on practical, measurable outcomes—time saved, revenue increased, effort reduced.</li>
                            <li><b>Transparent AI</b>: You stay in control. We demystify the tech and keep you involved at every step.</li>
                            <li><b>Speed + Support</b>: Fast development cycles and real human support, whenever you need it.</li>
                            <li><b>Cheap</b>: Our goal is to deliver high-impact AI at a fraction of the typical industry cost.</li>
                        </ul>
                    </div>
                </div>
                <div className="aboutimage"><img className="about2image" src={ChatBot} alt="brainimage" style={{marginLeft: '20%'}}/></div>
            </div>

            <div className="letsbuild about">
                <div className="buildsubheading"><b>Whether you’re just exploring AI or ready to launch your first agent, we’re here to guide you end to end. Let’s build something intelligent, together.</b></div>
                <div className="consultbutton bottom" style={{ marginBottom: '10%' }} onClick={() => navigate('/consultation')}>Free Consultation</div>
            </div>

        </div>
    )
}

export default About